import VSM from '../components/vsm/VSM';

export default function VSMRemoteView() {
  return <VSM />;
}
